export const STUDIOS_TABLE_QUERY_KEY = ['studios', 'table'] as const;
